module.exports = __webpack_public_path__ + "img/WP2023-Dubai5.ddda4a19.jpg";